const config = { dev:'prod' }; export default config ;


// WEBPACK FOOTER //
// ./src/config/index.js